import { RecipientModel } from './recipient.model';
import { RecipientSearchResultsApiModel } from '../../../api/mailingLists/models/recipient-search-results.api.model';

export class RecipientSearchResultsModel {
    totalCount: number;
    recipients: RecipientModel[];

    constructor(apiModel: RecipientSearchResultsApiModel) {
        this.totalCount = apiModel.totalRecipients;
        this.recipients = apiModel.recipients.map(recipient => new RecipientModel(recipient));
    }
}
